import React from 'react'
import ImageTag from '../ImageTag/Index'
import Featureslider from '../Gallery/Featureslider'
import Container from '../Container/Index'
import Title from '../Title/Index'

const Outsourcecontent = ({Data}) => {
  return (
    <>
    <Container containerClass={'float-end'}>
      <div className='col-lg-7 col-sm-12 col-12 m-auto' >
      {Data.imagePath ? (
    <>
      <ImageTag ImagePath={Data.imagePath} ImageAlt={Data.heading}/></> ) : (
     <> <div className='col-12 float-start Noimage flex-center h-100'>
     <ImageTag ImageAlt={'No Image Found'} /> 
   </div></>
     
    )}
    <div className='contentSection pt-lg-5 pt-3 col-12 float-start'>
    <Title secondHeading={Data.heading} _class={'mb-3 text-lg-start'}/>
 {Data.outsourceData?.length > 0 ? (
Data.outsourceData.map((items, index) => (
<div className='col-12 float-start serviceContent p-lg-4 pb-0 text-lg-start text-center' key={index}  data-aos="fade-up"
data-aos-offset="100"
data-aos-duration="500"
data-aos-once="true"
data-aos-easing="ease-in-sine">
<h3 className='text-black'>{items.heading}</h3>
<ul>
{items.listPoint.map((list, i) => {
return (
<li dangerouslySetInnerHTML={{ __html: list }} key={i} />
);
})}
</ul>
</div>
))
) : null}

    </div>
      </div>
    </Container>
    {Data?.featureData?.length > 0 ? ( <Featureslider Data={Data} slidesPerView={2.8} secondSlider={'hoverEffect'} spaceBetween={50}/>  ) : (null)}
    </>
  )
}

export default Outsourcecontent